module.exports = __webpack_public_path__ + "img/option_play_vip.8c3e2582.png";